import { render } from "./RelationshipEditor.vue?vue&type=template&id=2b6997a7&scoped=true"
import script from "./RelationshipEditor.vue?vue&type=script&lang=js"
export * from "./RelationshipEditor.vue?vue&type=script&lang=js"

import "./RelationshipEditor.vue?vue&type=style&index=0&id=2b6997a7&scoped=true&lang=css"
import "./RelationshipEditor.vue?vue&type=style&index=1&id=2b6997a7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6997a7"]])

export default __exports__